export default {
  getEncuestadoTpl: state => {
    let table = 'Encuestado'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
